import { render } from "./my-exchange-list.vue?vue&type=template&id=135c1dbf&scoped=true&ts=true"
import script from "./my-exchange-list.vue?vue&type=script&lang=ts"
export * from "./my-exchange-list.vue?vue&type=script&lang=ts"

import "./my-exchange-list.vue?vue&type=style&index=0&id=135c1dbf&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135c1dbf"]])